import { DISCOUNT_MANAGEMENT } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IDiscountManagementRepository } from "features/discountManagement/domain/repositories/IDiscountManagementRepository";
import { injectable } from "tsyringe";
import { DiscountManagementFormRequestModel } from "./model/DiscountManagementFormRequestModel";
import { DiscountManagementRequestModel } from "./model/DiscountManagementRequestModel";
import { DiscountManagementResponseModel } from "./model/DiscountManagementResponseModel";

@injectable()
export class DiscountManagementImpl implements IDiscountManagementRepository {
  async getList(
    params: DiscountManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<DiscountManagementResponseModel>> {
    return await client?.get(DISCOUNT_MANAGEMENT.LIST, params);
  }

  async getDetail(
    code: string,
  ): Promise<BaseApiResponseModel<DiscountManagementResponseModel>> {
    return await client?.get(`${DISCOUNT_MANAGEMENT.DETAIL}/${code}`);
  }

  async create(
    body: DiscountManagementFormRequestModel,
  ): Promise<BaseApiResponseModel<DiscountManagementResponseModel>> {
    return await client?.post(DISCOUNT_MANAGEMENT.CREATE, body);
  }

  async update(
    body: DiscountManagementFormRequestModel,
  ): Promise<BaseApiResponseModel<DiscountManagementResponseModel>> {
    return await client?.post(DISCOUNT_MANAGEMENT.UPDATE, body);
  }
}
